import React, { useEffect } from 'react'
import { Grid } from '@mui/material'
import { UseFormReturn, useWatch } from 'react-hook-form'
import CardActions from '../../../components/CardActions'
import { SectionBox } from '../../../components/FieldView'
import { AsyncSelect, ControlledDatePicker } from "../../../../../components/forms";
import { OperacionLEPFields, OperacionLEPUnidadNegocioFields } from "../types/fields";
import { useLoadOptions } from "../../../../../hooks/useLoadOptions";
import { useLEPSectorComercialTipos, useLEPUnidadNegocio } from "../hooks/useLEPCache";
import { SectorComercialFields, UnidadNegocioFields } from 'src/types';
import { useAFOPUSectorComercialTipos } from '../../afopu/hooks/useAFOPUCache';
import { OperacionAFOPUFields, OperacionAFOUnidadNegocioFields } from '../../afopu/types/fields';

interface SeccionLEPDatosOperacionProps {
    formMethods: UseFormReturn<any>
    codSistema: number,
    codPais: number
}

export const SeccionNuevoLEPDatosOperacion = ({ formMethods, codSistema, codPais }: SeccionLEPDatosOperacionProps) => {
    const { control, setValue } = formMethods

    const unidadNegocioHook = useLEPUnidadNegocio(codPais, codSistema)

    useEffect(() => {
        if (unidadNegocioHook.unidadNegocio && unidadNegocioHook.unidadNegocio.length > 0) {
            const opcionDefault = unidadNegocioHook.unidadNegocio.find(
                opcion => opcion[UnidadNegocioFields.UnidadNegocioTipo] === 4
            )

            if (opcionDefault) {
                setValue(OperacionLEPFields.CodUnidadNegocio, opcionDefault.id)
            }
        }
    }, [unidadNegocioHook.unidadNegocio, setValue])

    const loadUnidadNegocio = useLoadOptions({
        data: unidadNegocioHook.unidadNegocio,
        loading: unidadNegocioHook.isLoading,
        isError: unidadNegocioHook.isError,
        error: unidadNegocioHook.error
    });

    const watchedUnidadNegocio = useWatch({ control: control, name: OperacionAFOPUFields.CodUnidadNegocio });


    const sectorComercialTipos = useLEPSectorComercialTipos(watchedUnidadNegocio, codSistema);
    const loadSectorComercial = useLoadOptions({
        data: sectorComercialTipos.sectorComercialTipos,
        loading: sectorComercialTipos.isLoading,
        isError: sectorComercialTipos.isError,
        error: sectorComercialTipos.error
    });

    return (
        <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
            <SectionBox>
                <Grid item xs={12} md={4}>
                    <AsyncSelect
                        label={'Unidad de Negocio'}
                        name={OperacionLEPFields.CodUnidadNegocio}
                        valueField={SectorComercialFields.UnidadNegocioCodigo}
                        loadOptions={loadUnidadNegocio} control={control}
                        selectNotNulleable
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <AsyncSelect
                        label={'Equipo Comercial'}
                        name={OperacionLEPFields.CodSectorComercial}
                        valueField={SectorComercialFields.SectorComercialCodigo}
                        loadOptions={loadSectorComercial} control={control}
                        selectNotNulleable
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <ControlledDatePicker name={OperacionLEPFields.FechaAprobacion} control={control}
                        label='Fecha Solicitud' />
                </Grid>
                <Grid item xs={12} md={4}>
                    <ControlledDatePicker name={OperacionLEPFields.FechaVencimiento} control={control}
                        label='Fecha Vencimiento' />
                </Grid>
            </SectionBox>
        </CardActions>
    )
}
